import script from "./loginSwiper.vue?vue&type=script&setup=true&name=mainSwiper&lang=js"
export * from "./loginSwiper.vue?vue&type=script&setup=true&name=mainSwiper&lang=js"

const __exports__ = script;

export default __exports__